import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import "../styles/Unbind.css";
import { getAllMerchants, unbindDevice } from "../api/api";
import { FaStore, FaCreditCard } from "react-icons/fa";
import { useFormik } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  mid: Yup.string().required("MID is required"),
  tid: Yup.string().required("TID is required"),
});

const Unbind = ({ isSidebarOpen }) => {
  const [loading, setLoading] = useState(true);
  const [merchants, setMerchants] = useState([]);
  const [tids, setTids] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const formik = useFormik({
    initialValues: { mid: "", tid: "" },
    validationSchema,
    onSubmit: async (values) => {
      try {
        if (!selectedDevice || !selectedDevice.serialNumber) {
          alert("⚠️ Device is already not binded.");
          return;
        }
        setLoading(true);
        const data = await unbindDevice(values.mid, values.tid);
        if (data.isSuccess) {
          await fetchMerchants();
          formik.resetForm(); // 🔹 Reset form values to initial state
          setTids([]);
          alert(`✅ Success: ${data.message}`);
        } else {
          alert(`❌ Error: ${data.message}`);
        }
      } catch (err) {
        alert(`❌ Error: ${err.message || err}`);
      } finally {
        setLoading(false);
      }
    },
  });
  const fetchMerchants = async () => {
    try {
      setLoading(true);
      const res = await getAllMerchants();
      if (res?.data) {
        const filteredMerchants = res.data.filter(
          (m) => m.terminals && m.terminals.length > 0
        );
        setMerchants(filteredMerchants);
      }
    } catch (err) {
      console.error("Error fetching merchants:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMerchants();
  }, []);

  useEffect(() => {
    if (formik.values.mid && formik.values.tid) {
      const merchant = merchants.find((m) => m.MID === formik.values.mid);

      const terminal = merchant?.terminals?.find(
        (t) => t.TID === formik.values.tid
      );

      setSelectedDevice(terminal || null);
    } else {
      setSelectedDevice(null);
    }
  }, [formik.values.mid, formik.values.tid, merchants]);

  // Update TIDs when MID changes
  useEffect(() => {
    if (formik.values.mid) {
      const merchant = merchants.find((m) => m.MID === formik.values.mid);
      if (merchant && merchant.terminals) {
        setTids(
          merchant.terminals.map((t) => ({
            label: t.TID,
            value: t.TID,
          }))
        );
      } else {
        setTids([]);
      }
    } else {
      setTids([]);
    }
  }, [formik.values.mid, merchants]);

  
if (loading && merchants.length > 0) {
    return (
      <div className={`reporting-container ${isSidebarOpen ? "shifted" : ""}`}>
        <div className="db-loader">
          <div className="loader-spinner" />
          <p>Unbinding Device...</p>
        </div>
      </div>
    );
  }
if (loading) {
    return (
      <div className={`reporting-container ${isSidebarOpen ? "shifted" : ""}`}>
        <div className="db-loader">
          <div className="loader-spinner" />
          <p>Fetching Merchant IDs...</p>
        </div>
      </div>
    );
  }
  return (
    <div className={`reporting-container ${isSidebarOpen ? "shifted" : ""}`}>
      <form
        onSubmit={formik.handleSubmit}
        className="reporting-form"
        noValidate
      >
        {/* MID Dropdown */}
        <div className="form-group">
          <label>MID</label>
          <div className="input-with-icon">
            <FaStore className="input-icon" />
            <Dropdown
              name="mid"
              value={formik.values.mid}
              options={merchants.map((m) => ({
                label: m.MID,
                value: m.MID,
              }))}
              onChange={(e) => {
                formik.setFieldValue("mid", e.value);
                formik.setFieldValue("tid", "");
                setSelectedDevice(null);
              }}
              placeholder="Select MID"
              className="form-input"
              filter
              showClear
              filterBy="label"
            />
          </div>
          {formik.touched.mid && formik.errors.mid && (
            <p className="error-message">{formik.errors.mid}</p>
          )}
        </div>

        {/* TID Dropdown */}
        <div className="form-group">
          <label>TID</label>
          <div className="input-with-icon">
            <FaCreditCard className="input-icon" />
            <Dropdown
              name="tid"
              value={formik.values.tid}
              options={tids}
              onChange={(e) => formik.setFieldValue("tid", e.value)}
              placeholder="Select TID"
              className="form-input"
              filter
              showClear
              disabled={!formik.values.mid}
              filterBy="label"
            />
          </div>
          {formik.touched.tid && formik.errors.tid && (
            <p className="error-message">{formik.errors.tid}</p>
          )}
        </div>

        {selectedDevice && (
          <div className="form-group full-width">
            <label>Device Name</label>
            <div className="device-info-box">
              {selectedDevice.serialNumber || "N/A"}
            </div>
          </div>
        )}

        <div className="form-actions">
          <button type="submit" className="report-btn apply" disabled={loading}>
            {loading ? "Processing..." : "Unbind"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Unbind;
